import React, { useState } from 'react';
import { TableRow } from '../TableRow/TableRow'
import './Table.scss'
import { tableData } from './tableData'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export const Table = () => {

    const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
    const [chartData, setChartData] = useState<Highcharts.Options | null>(null);

    const handleRowClick = (id: number, currentDay: number, yesterday: number, thisWeek: number) => {
        if (selectedRowId === id) {
            setSelectedRowId(null);
            setChartData(null);
        } else {
            setSelectedRowId(id);
            const chartOptions: Highcharts.Options = {
                chart: {
                    width: null,
                    height: 300,
                },
                title: {
                    text: '',
                },
                xAxis: {
                    categories: ['Вчера', 'Сегодня', 'Эта неделя'],
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    lineWidth: 1,
                    lineColor: 'black',
                },
                series: [
                    {
                        name: 'Значение',
                        data: [yesterday, currentDay, thisWeek],
                        type: 'line',
                        color: '#228B22',
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            fillColor: '#228B22',
                            lineColor: '#228B22'
                        },
                    },
                ],
            };
            setChartData(chartOptions);
        }
    };

    return (
        <div className="container">
            <table className="table">
                <thead>
                    <tr>
                        <th className="table__header">Показатель</th>
                        <th className="table__header">Текущий день</th>
                        <th className="table__header">Вчера</th>
                        <th className="table__header">Этот день недели</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData && tableData.map((data) => (
                        <React.Fragment key={data.id}>
                            <tr
                                className={`table__row ${selectedRowId === data.id ? 'table__row--selected' : ''}`} // Добавляем класс для выделения
                                onClick={() => handleRowClick(data.id, data.currentDay, data.yesterday, data.thisWeek)}
                            >
                                <TableRow data={data} />
                            </tr>
                            {selectedRowId === data.id && chartData && (
                                <tr>
                                    <td colSpan={4}>
                                        {<HighchartsReact
                                            highcharts={Highcharts}
                                            options={chartData}
                                        />}
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>


    )
}